
angular.module('forms.fields.binary', [])
.directive('persistentBinaryField', function($q, pinesNotifications, $translate){
    var slice = Array.prototype.slice;
    
    var readFile = function (file, setProgress) {
        var deferred = $q.defer();
        var isResolved = false;

        var reader = new FileReader()
        reader.onerror = function(e) {
            if (!isResolved) deferred.reject({file: file, event: e});
            isResolved = true;
        }
        reader.onload = reader.onloadend = function(e){
            if (!isResolved) {
                if (e.target.result.length) {
                    deferred.resolve(e.target.result);
                } else {
                    deferred.reject({file: file, event: e});
                }
            }
            isResolved = true;
        }
        reader.onprogress = function(e){
            if (setProgress && e.total) {
                setProgress({file: file, event: e});
            }
        }

        if (file.size <= 100 * 1025 * 1024) {
            reader.readAsDataURL(file);
        } else {
            deferred.reject({file: file, event: null, message: $translate.instant('File too large')});
        }

        return deferred.promise;
    }
    
    var updateFilesMetadata = function(files) {
		console.debug('Update files meta:', files);
		if (files.length > 0) {
			var file = files[0];
			object.mime = file.type;
			object.filename = file.name;
		} else {
			object.mime = null;
			object.filename = null;
		}
	}

    return {
        restrict: 'A',
        scope: { 'onRead': '&', 'onProgress': '&', 'onError': '&' },
        require: '?ngModel',
        link: function(scope, element, attrs, ngModel){
            if(!ngModel) return;

            var setProgress = function(info) {
                scope.$apply(function(){
                    scope.onProgress({$event: info.event, file: info.file});
                });
            }

            ngModel.$render = function(){}

            element.bind('change', function(e){
                var element = e.target;
				
				
                $q.all(slice.call(element.files, 0).map(function(reader){return readFile(reader, setProgress);}))
                .then(function(values){
                    if (element.multiple) ngModel.$setViewValue(values);
                    else ngModel.$setViewValue(values.length ? values[0] : null);
                    scope.onRead({file: element.files.length>0? element.files[0] : {}});
                }).catch(function(info){
                    console.error('Binary field error', info.file, info.event);
                    pinesNotifications.notify({
                        title: $translate.instant('An error occured while loading the file'),
                        text: info.message || info.file.name,
                        type: 'error'
                    });
                    scope.onError({$event: info.event, file: info.file});
                });
                
            });//change

        },//link

    };//return

})



















.directive('binaryHashField', function($q, pinesNotifications, $translate, $cookies, FileUploader){
    return {
		bindToController: {
			field: '<',
			object: '=fieldObject',
		},
		controller: function($parse, $scope, Classes) {
            this.uploader = new FileUploader({
                url: this.field.client.upload_url,
                autoUpload: true,
                removeAfterUpload: true,
                headers: {'X-XSRF-TOKEN': $cookies.get('XSRF-TOKEN')},
                formData: []
            });

            var self = this;
            this.current_item = null;
            this.current_item_error = '';

            // CALLBACKS

            this.uploader.onBeforeUploadItem = function(item) {
                console.info('onBeforeUploadItem', item);
                self.current_item = item;
                self.current_item_error = '';
                //item.formData.push({parent_vid: $scope.object.__vid});

                // update meta
                self.object.mime = item.file.type;
                self.object.filename = item.file.name;
            };
            this.uploader.onSuccessItem = function(fileItem, response, status, headers) {
                console.info('onSuccessItem', fileItem, response, status, headers);
                response = JSON.parse(response);
                self.object[self.field.name] = {hash: response}
                self.current_item = null;
            };
            this.uploader.onErrorItem = function(fileItem, response, status, headers) {
                console.error('Binary hash field error', fileItem, response, status, headers);
                var message = response.message || 'unknown reason';
                try {
                    var message = JSON.decode(response).message;
                } catch (e) {}
                self.current_item_error = 'Error (' + status + '): ' + message;
                pinesNotifications.notify({
                    title: $translate.instant('An error occured while loading the file'),
                    text: message || fileItem.file.name,
                    type: 'error'
                });
                self.current_item = null;
            };
            this.uploader.onCancelItem = function(fileItem, response, status, headers) {
                console.info('onCancelItem', fileItem, response, status, headers);
                self.current_item = null;
            };
            this.uploader.onCompleteItem = function(fileItem, response, status, headers) {
                console.info('onCompleteItem', fileItem, response, status, headers);
            };
        },
        controllerAs: '$hash'
    }


})

